// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_2DwjW","width-100":"width-100_VsDAf"};